import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendMessageDialogComponent } from './components/send-message-dialog/send-message-dialog.component';

import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/appclient';



@NgModule({
  declarations: [
    SendMessageDialogComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    TransportInfoPanelModule,
    MaterialModule
  ]
})
export class SendMessageModule { }
